// extracted by mini-css-extract-plugin
export default {"itemContainer":"AdultFeedingItem_itemContainer__CX22x","itemLine":"AdultFeedingItem_itemLine__mjlVa","input":"AdultFeedingItem_input__OQf+r","price":"AdultFeedingItem_price__jazxA"};